import DNDBase from '@components/dnd/base';
import useAction from '@hooks/useAction';
import useStores from '@hooks/useStore';
import { observer } from 'mobx-react';

export const UiTableImporter = observer(() => {
  const { dndStore } = useStores();
  const action = useAction();
  const uiDnd = dndStore.get(action?.uiDndId);
  if (!uiDnd) {
    return <></>;
  }

  return <DNDBase dnd={uiDnd} hasToolbar />;
});
